import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import OrderForm from "@/pages/OrderForm";
import OrderDetail from "@/pages/OrderDetail";
import TodayProduction from "@/pages/TodayProduction";
import CalendarView from "@/pages/CalendarView";
import DeliveryPickup from "@/pages/DeliveryPickup";
import Customers from "@/pages/Customers";
import Expenses from "@/pages/Expenses";
import Reports from "@/pages/Reports";
import Templates from "@/pages/Templates";
import Extract from "@/pages/Extract";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import ProductionSheet from "@/pages/ProductionSheet";

function Protected({ children, ownerOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-[#4B5563]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (ownerOnly && user.role !== "owner") return <Navigate to="/production" replace />;
  return children;
}

function StaffHome() {
  const { user } = useAuth();
  if (user?.role === "owner") return <Dashboard />;
  return <Navigate to="/production" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/print/:id" element={<Protected><ProductionSheet /></Protected>} />
      <Route path="/print" element={<Protected><ProductionSheet /></Protected>} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<StaffHome />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/new" element={<Protected ownerOnly><OrderForm /></Protected>} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/orders/:id/edit" element={<OrderForm />} />
        <Route path="/production" element={<TodayProduction />} />
        <Route path="/calendar" element={<CalendarView />} />
        <Route path="/delivery" element={<DeliveryPickup />} />
        <Route path="/customers" element={<Protected ownerOnly><Customers /></Protected>} />
        <Route path="/expenses" element={<Protected ownerOnly><Expenses /></Protected>} />
        <Route path="/reports" element={<Protected ownerOnly><Reports /></Protected>} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/extract" element={<Protected ownerOnly><Extract /></Protected>} />
        <Route path="/users" element={<Protected ownerOnly><Users /></Protected>} />
        <Route path="/settings" element={<Protected ownerOnly><Settings /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
